var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.user
      ? _c("ul", { staticClass: "main-header__list" }, [
          _c("li", { staticClass: "main-header__item" }, [
            _c(
              "a",
              {
                staticClass: "main-header__link",
                attrs: { href: "javascript:;" },
                on: {
                  click: function($event) {
                    return _vm.openProfile()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$helpers.trans("auth.profile")))]
            )
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "main-header__item" }, [
            _c(
              "a",
              {
                staticClass: "main-header__link",
                attrs: { href: "javascript:;" },
                on: {
                  click: function($event) {
                    return _vm.logout()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$helpers.trans("auth.logout")))]
            )
          ])
        ])
      : _c("ul", { staticClass: "main-header__list" }, [
          _c("li", { staticClass: "main-header__item" }, [
            _c(
              "a",
              {
                staticClass: "main-header__link",
                attrs: { href: "javascript:;" },
                on: {
                  click: function($event) {
                    return _vm.openLogin()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$helpers.trans("auth.login")))]
            )
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "main-header__item" }, [
            _c(
              "a",
              {
                staticClass: "main-header__link",
                attrs: { href: "javascript:;" },
                on: {
                  click: function($event) {
                    return _vm.openRegister()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$helpers.trans("auth.register")))]
            )
          ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61e27f04", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61e27f04","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./js/components/package/RF/Member/FrontNav.vue
// module id = 257
// module chunks = 17